import storageService from '@app/services/storageService'

import { SIDE_MENU_COLLAPSE_VALUE, SIDE_MENU_STORAGE_KEY } from '@app/hooks/useSideMenu/constants'

export const getSideMenuToggleInitialValue = (): boolean => {
  const savedIsCollapse = storageService.getItem(SIDE_MENU_STORAGE_KEY)
  return savedIsCollapse === SIDE_MENU_COLLAPSE_VALUE
}

export const setStorageSideMenu = (value: boolean): void => {
  storageService.setItem(SIDE_MENU_STORAGE_KEY, String(value))
}
